import { pack, unpack } from './packer';
export const encode = (types, values) => {
  return pack(types, values, new Uint8Array());
};
export const decode = (types, buffer) => {
  return unpack(types, buffer);
};
//# sourceMappingURL=abi.js.map